import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ComprobanteContableDetallePage",
    data() {
        let ss = new MainService();
        return {
            msg: "ComprobanteContableDetallePage",
            ss: ss,
            ajax: {
                "url": ss.indexComprobanteContableDetalle(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Monto', name: 'ComprobanteContableDetalle', title: 'Unidad Gerencial' },
                { data: 'Tipo', name: 'Sigla', title: 'Sigla' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            comprobanteContableDetalles: [],
            comprobantecontabledetalle: {},
            comprobantecontables:[],
            cuentas:[],
            subcuentas:[],
            reparticions:[],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getComprobanteContable() {
            this.ss.listComprobanteContable().then(
                (result) => {
                    let response = result.data;
                    this.comprobantecontables = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getCuenta() {
            this.ss.listCuenta().then(
                (result) => {
                    let response = result.data;
                    this.cuentas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getSubcuenta() {
            this.ss.listSubcuenta().then(
                (result) => {
                    let response = result.data;
                    this.subcuentas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getReparticion() {
            this.ss.listReparticion(0).then(
                (result) => {
                    let response = result.data;
                    this.reparticions = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newComprobanteContableDetalle() {
            this.comprobantecontabledetalle = {};
            this.$refs['frm-comprobantecontabledetalle'].show();
        },
        showComprobanteContableDetalle(id) {
            this.isLoading=true;
            this.ss.showComprobanteContableDetalle(id).then(
                (result) => {
                    let response = result.data;
                    this.comprobantecontabledetalle = response.data;
                    this.$refs['view-comprobantecontabledetalle'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editComprobanteContableDetalle() {
            this.$refs['frm-comprobantecontabledetalle'].show();
            this.$refs['view-comprobantecontabledetalle'].hide();
        },
        cancelComprobanteContableDetalle() {
            if (this.comprobantecontabledetalle.id) {
                this.$refs['view-comprobantecontabledetalle'].show();
            }
            this.$refs['frm-comprobantecontabledetalle'].hide();
        },
        saveComprobanteContableDetalle() {
            this.ss.storeComprobanteContableDetalle(this.comprobantecontabledetalle).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-comprobantecontabledetalle'].hide();
                    this.$refs['datatable-comprobantecontabledetalle'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteComprobanteContableDetalle() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyComprobanteContableDetalle(this.comprobantecontabledetalle)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-comprobantecontabledetalle'].hide();
                                this.$refs['datatable-comprobantecontabledetalle'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-ComprobanteContableDetalle').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showComprobanteContableDetalle(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
            this.getCuenta();
            this.getReparticion(0);
            this.getSubcuenta();
            this.getComprobanteContable();
        }
    }
};
